module.exports = __webpack_public_path__ + "img/service_image2.2a4b285b.jpg";